<template>
    <div class="CampaignHistoryCall">
        <div class="header">
            <div>
                <div class="title">{{ $f.tc("historyCall") }}</div>
                <div class="subtitle">
                    ID:
                    <span>{{ callId }}</span>
                </div>
            </div>
            <v-btn small icon @click="close">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
        <div ref="MessageScroll">
            <v-tabs class="detail-tabs" slider-color="#E4EDFA" v-model="currentTab">
                <v-tab>{{ $f.tc('overview') }}</v-tab>
                <v-tab active> {{ $f.tc('transcript') }}</v-tab>
                <v-tabs-items>
                    <v-tab-item>
                        <CampaignHistoryOverview
                            :active-call-id="callId"
                            :call-summary="callSummary"
                        ></CampaignHistoryOverview>
                    </v-tab-item>
                    <v-tab-item>
                        <CampaignHistoryTranscription
                            :active-call-id="callId"
                            @updateCallSummary="getCallSummary"
                        ></CampaignHistoryTranscription>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
        </div>
    </div>
</template>

<script>

import lodash from 'lodash'
import {mapState} from 'vuex'
import CampaignHistoryTranscription from "@/views/Campaign/CampaignHistoryTranscription.vue";
import CampaignHistoryOverview from "@/views/Campaign/CampaignHistoryOverview.vue";

export default {
    name: "CampaignHistoryCall",
    components: {CampaignHistoryOverview, CampaignHistoryTranscription},
    data() {
        return {
            currentTab: 1,
            messageList: [],
            isLoading: false,
            callSummary: '',
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign,
        }),
        callId() {
            return this.$route.query.call_id || ''
        }
    },
    methods: {
        close() {
            let query = this.$utils.cloneObject(this.$route.query)
            delete query.call_id
            delete query.from
            delete query.to
            if (!lodash.isEqual(query, this.$route.query)) {
                this.$router.replace({
                    query: query
                })
            }
        },
        getCallSummary(callSummary) {
            this.callSummary = callSummary
        },
    },
}
</script>

<style scoped lang="scss">
@import "../Scenario/chat.scss";

.CampaignHistoryCall {
    border-left: 1px solid #d9d9d9;
    flex: 1;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f0f0f0;
        height: 58px;
        padding: 0 5px 0 12px;
    }

    .title {
        font-size: 16px !important;
        font-family: "open sans bold", serif !important;
    }

    .subtitle {
        margin-top: 6px;
        font-size: 13px;
    }

    max-height: calc(100vh - 295px);
}


</style>
